import { render } from "./packageexpirylist.vue?vue&type=template&id=a3dac462&scoped=true"
import script from "./packageexpirylist.vue?vue&type=script&lang=js"
export * from "./packageexpirylist.vue?vue&type=script&lang=js"

import "./packageexpirylist.vue?vue&type=style&index=0&id=a3dac462&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3dac462"]])

export default __exports__